import React from "react";
import PropTypes from "prop-types";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import withStyles from "@material-ui/core/styles/withStyles";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";

import ReactSelect, {components as componentesSelect} from "react-select";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import {primaryBoxShadow, primaryColor} from "assets/jss/material-dashboard-pro-react.jsx";

// Faz o react-select passar por um Select do MUI: mesmo underline, tipografia e menu do tema
// (valores equivalentes aos de customSelectStyle.jsx, que o react-select não consegue receber como classes)
const estilos = {
  container: base => ({...base, marginTop: 20}),
  control: (base, state) => ({
    ...base,
    minHeight: 0,
    padding: "12px 0 7px",
    backgroundColor: "transparent",
    border: 0,
    borderRadius: 0,
    borderBottom: "1px solid #D2D2D2",
    // underline de foco por dentro, para não empurrar o conteúdo como faria um border de 2px
    boxShadow: state.isFocused ? "inset 0 -2px 0 0 " + primaryColor : "none",
    "&:hover": {borderBottom: "1px solid #D2D2D2"}
  }),
  valueContainer: base => ({...base, padding: 0}),
  singleValue: base => ({...base, margin: 0, fontSize: ".75rem", color: "#3C4858", lineHeight: "1.42857"}),
  placeholder: base => ({...base, margin: 0, fontSize: ".75rem", color: "#AAAAAA", lineHeight: "1.42857"}),
  input: base => ({...base, margin: 0, padding: 0, fontSize: ".75rem", color: "#3C4858"}),
  indicatorSeparator: () => ({display: "none"}),
  dropdownIndicator: base => ({...base, padding: 0, color: "rgba(0, 0, 0, 0.54)"}),
  clearIndicator: base => ({...base, padding: 0, color: "rgba(0, 0, 0, 0.54)"}),
  menu: base => ({...base, borderRadius: 4, marginTop: 2}),
  menuList: base => ({...base, padding: "5px 0", maxHeight: 266}),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    lineHeight: 2,
    padding: "10px 20px",
    margin: "0 5px",
    width: "auto",
    borderRadius: 2,
    cursor: "pointer",
    transition: "all 150ms linear",
    color: state.isFocused || state.isSelected ? "#FFFFFF" : "#333",
    backgroundColor: state.isFocused || state.isSelected ? primaryColor : "transparent",
    ...(state.isFocused || state.isSelected ? primaryBoxShadow : {}),
    "&:active": {backgroundColor: primaryColor, color: "#FFFFFF"}
  }),
  menuPortal: base => ({...base, zIndex: 1500})
};

// seta igual à do Select do MUI (o chevron do react-select destoa)
const IndicadorSelect = (props) => <componentesSelect.DropdownIndicator {...props}>
  <ArrowDropDown/>
</componentesSelect.DropdownIndicator>;

/**
 * Select com pesquisa com o aspeto do Select do MUI usado no resto do projeto.
 * Trabalha com valores simples (como o Select do MUI), não com as opções do react-select.
 */
const SelectPesquisa = (props) => {
  const {
    classes, labelText, id, options, value, onChange, placeholder, pesquisa, semOpcoesTexto,
    formControlProps, labelProps, ...resto
  } = props;

  const opcaoSelecionada = options.find(o => o.value === value) || null;

  return <FormControl fullWidth {...formControlProps} className={classes.selectFormControl + (formControlProps?.className ? " " + formControlProps.className : "")}>
    {labelText !== undefined && <InputLabel shrink htmlFor={id} className={classes.selectLabel} {...labelProps}>
      {labelText}
    </InputLabel>}
    <ReactSelect
      inputId={id}
      placeholder={placeholder}
      noOptionsMessage={() => semOpcoesTexto}
      options={options}
      value={opcaoSelecionada}
      onChange={(opcao) => onChange(opcao ? opcao.value : null, opcao)}
      isSearchable={pesquisa}
      // pode ser usado dentro de modais: o menu vai para o body para não ser cortado
      menuPortalTarget={document.body}
      components={{DropdownIndicator: IndicadorSelect}}
      styles={estilos}
      {...resto}
    />
  </FormControl>;
};

SelectPesquisa.defaultProps = {
  placeholder: "Escolha uma opção",
  semOpcoesTexto: "Sem opções disponíveis",
  pesquisa: true
};

SelectPesquisa.propTypes = {
  classes: PropTypes.object.isRequired,
  /** Opções no formato {value, label} */
  options: PropTypes.array.isRequired,
  /** Valor selecionado (o `value` da opção, não a opção) */
  value: PropTypes.any,
  /** Recebe (valor, opcao); valor é null quando nada está selecionado */
  onChange: PropTypes.func.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  semOpcoesTexto: PropTypes.string,
  /** Desligar para ficar igual a um Select normal, sem caixa de pesquisa */
  pesquisa: PropTypes.bool,
  formControlProps: PropTypes.object
};

export default withStyles(customSelectStyle)(SelectPesquisa);
